





















































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { FormRule } from '@/types/formRules.d.ts'
import NbFormItem from '@/components/NbForm/index.vue'

import { cusElForm } from '@/types/form'

@Component({
  components: {
    NbFormItem,
  },
})
export default class Step4 extends Vue {
  /**
   *
   * name 计划名称       string
   * code 计划编码        string
   * objectName 实施对象    string
   * groupName  计划分组    string
   * description  计划说明  string
   * implement 执行器         []
   *
   *  name: step1Form.name,
                 code: step1Form.code,
                 objectName: step1Form.objectName,
                 groupName: step1Form.categoryArr[step1Form.categoryName].name,
                 description: step1Form.description,
                 implement: step3Form
   */
  @Prop() step4Form!: any;
  // nextStatus = false // 下一步状态/
  validatePass = (rule: any, value: any, cb: any) => {
    if (value === '') {
      // this.nextStatus = false
      cb(new Error('校验不通过，编码仅支持大小写字母，请检查您的编码'))
      return
    }
    // this.nextStatus = true
    cb()
  };
  rules: any = {
    number: { validator: this.validatePass, trigger: 'blur' },
  };

  // 规则校验状态
  vaildSubmit(cb: Function) {
    // (this.$refs.form as cusElForm).validate((valid: boolean) => {
    //   if (valid) {
    // eslint-disable-next-line standard/no-callback-literal
    cb(true)
    // } else {
    //   cb(valid)
    //   return false
    // }
    // })
  }
}
